/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input, OnInit, output } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import {TaskListService} from "./task-list.service";
import {TaskViewVoModel} from "@well/delivery-libs/task-management/domain";
import { SharedComponentsModule } from '@well/shared-components';
import { AsyncPipe, NgForOf } from '@angular/common';
import { TaskCardSummaryComponent } from '../task-card-summary/task-card-summary.component';

@Component({
  selector: 'well-tasks-list',
  templateUrl: './tasks-list.component.html',
  styleUrls: ['./tasks-list.component.scss'],
  providers: [TaskListService],
  imports: [ SharedComponentsModule, NgForOf, AsyncPipe, TaskCardSummaryComponent],
  standalone: true,
})
export class TasksListComponent implements OnInit {
  @Input() segmentSelectedRsUuid: string | undefined = undefined;
  solutionDeleted = output<void>();

  $tasks: Observable<JsonApiResource<TaskViewVoModel[], JsonApiListResourceMetadataBase>> | undefined = undefined;

  constructor(private taskListService: TaskListService) {}

  ngOnInit() {
    if(this.segmentSelectedRsUuid) {
      this.$tasks = this.taskListService.loadTaskListFromSegment(this.segmentSelectedRsUuid);
    }
  }
}
